import jQuery from 'jquery';
const $ = jQuery;
// import 'bootstrap';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';

import 'slick-carousel';
import Client from 'shopify-buy';

import caretLeft from './assets/icons/caret-left.svg';
import caretRight from './assets/icons/caret-right.svg';

/*
|--------------------------------------------------------------------------
| Sticky Social Share
|--------------------------------------------------------------------------
*/


/*
|--------------------------------------------------------------------------
| Home Page Toggle Video Sound
|--------------------------------------------------------------------------
*/
const homeVideo = $('.page-home .hero-video video');

$(document).ready(function() {
    if (homeVideo.prop('muted')) {
        $('.toggle-video-sound .sound-off').show();
    } else {
        $('.toggle-video-sound .sound-on').show();
    }

    /*
    |--------------------------------------------------------------------------
    | Home Page Auto-Pause Video
    |--------------------------------------------------------------------------
    */    
    if (jQuery("body").hasClass("home") && typeof homeVideo !== 'undefined') {
        jQuery(window).scroll(function(){
            let currentStatus = document.querySelector('video').playing;
            let desiredStatus = true;

            if(jQuery(window).scrollTop() > 400)
            {
                desiredStatus = false;
            }
            else
            {
                desiredStatus = true;
            }

            if(currentStatus !== desiredStatus)
            {
                try {
                    if(desiredStatus === true)
                    {
                        document.querySelector('video').play();
                    }
                    else
                    {
                        document.querySelector('video').pause();
                    }
                } catch (mediaErr) {
                    // We will ignore the error for now
                }
            }
        });
    }


    jQuery('.toggle-video-sound').click(function() {
        const video = $(this).parent().find('video');
        const soundOn = $(this).find('.sound-on');
        const soundOff = $(this).find('.sound-off');

        if (homeVideo.prop('muted')) {
            homeVideo.prop('muted', false);
            soundOn.show();
            soundOff.hide();
        } else {
            homeVideo.prop('muted', true);
            soundOn.hide();
            soundOff.show();
        }
    });
});

/*
|--------------------------------------------------------------------------
| Shopify Cart
|--------------------------------------------------------------------------
*/
const checkoutInfo = jQuery('.checkout-info');
const basketItemList = jQuery('.checkout-basket .item-list');


// Checkout actions
const checkoutClose = jQuery('.checkout-actions .-continue');
const checkoutProceed = jQuery('.checkout-actions .-checkout');

// Checkout totals
const productTotal = jQuery('.checkout-totals .product-total');
const shippingTotal = jQuery('.checkout-totals .shipping-total');
const totalPrice = jQuery('.checkout-totals .total-price');

// 
const basketContainer = jQuery('.basket-summary');
const basketButton = jQuery('.basket-summary > button');
const basketTotal = jQuery('.basket-summary .total');
const basketCount = jQuery('.basket-summary .items-count');
const client = Client.buildClient({
    domain: 'storror.myshopify.com',
    storefrontAccessToken: '547c8444445fe30f6f4a80a6aa7b7b44',
});

// Bindings for cart changes
const addButton = '.checkout-basket .quantity .add';
const subtractButton = '.checkout-basket .quantity .subtract';
const removeButton = '.checkout-basket .remove';

function updateCartData(checkout) {
    if (checkout && Array.isArray(checkout.lineItems)) {
        const totalItems = checkout.lineItems.reduce((total, item) => total + item.quantity, 0);

        // Update checkout data
        updateCheckoutData(checkout);

        // Only show basket counter if more than 0 items
        totalItems > 0 ? basketCount.show() : basketCount.hide();

        // Header items
        basketCount.text(totalItems);
        basketTotal.text('£' + checkout.totalPrice);

        // Checkout dropdown items
        checkoutProceed.attr('href', checkout.webUrl);
        productTotal.text('£' + checkout.subtotalPrice);
        totalPrice.text('£' + checkout.totalPrice);

        if (checkout.shippingLine) {
            shippingTotal.text('£' + checkout.shippingLine.price);
        } else {
            shippingTotal.text('£0.00');
        }
    }
}
window.updateCartData = updateCartData;

function addListeners(){

}

function increaseCartQuantity($productId, $quantity) {
    $quantity++;
    client.checkout.updateLineItems(checkout_id, [{
        id : $productId,
        quantity: $quantity
    }]).then((checkout) => {
        updateCartData(checkout);
    });
}

function decreaseCartQuantity($productId, $quantity) {
    $quantity--;
    if($quantity >= 1){
        client.checkout.updateLineItems(checkout_id, [{
            id : $productId,
            quantity: $quantity
        }]).then((checkout) => {
            updateCartData(checkout);
        });
    } else {
        let delete_item = confirm("Are you sure you wish to remove this from your cart?");
        if(delete_item){
            removeCartItem($productId);            
        }
        return false;
    }
}

function removeCartItem($productId) {
    client.checkout.removeLineItems(checkout_id, [
        $productId,
    ]).then((checkout) => {
        updateCartData(checkout);
    });
}

function updateCheckoutData(checkout) {
    // Empty the current checkout items
    basketItemList.empty();

    // Populate checkout items
    if (checkout && Array.isArray(checkout.lineItems)) {
        checkout.lineItems.forEach(item => {
            const str = createCheckoutItem(item);
            basketItemList.append(str);
        });
    }
}

function createCheckoutItem(item) {
    const { id, title, quantity, variant } = item;
    return `
        <li class="line-item" data-cart-id="${id}" data-cart-qty="${quantity}">
            <div class="product">
                <div class="image">
                    <img src="${variant.image.src}" alt="${variant.image.altText}" />
                </div>
                <div class="title">${title}</div>
            </div>
            <div class="variant">${variant.title}</div>
            <div class="quantity"><span class="add">+</span><span class="val">${quantity}</span><span class="subtract">-</span></div>
            <div class="amount">£${(variant.price * quantity).toFixed(2)}</div>
            <div class="remove">
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" class="svg-inline--fa fa-trash fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z"></path></svg>
            </div>
        </li>
    `;
}

jQuery(document).on('click', addButton, function(e){
        let $productId = jQuery(this).parents('.line-item').data('cart-id');
        let $qty = jQuery(this).parents('.line-item').data('cart-qty');
        increaseCartQuantity($productId, $qty);
})
jQuery(document).on('click', subtractButton, function(e){
        let $productId = jQuery(this).parents('.line-item').data('cart-id');
        let $qty = jQuery(this).parents('.line-item').data('cart-qty');
        decreaseCartQuantity($productId, $qty);
})
jQuery(document).on('click', removeButton, function(e){
        let $productId = jQuery(this).parents('.line-item').data('cart-id');
        let $qty = jQuery(this).parents('.line-item').data('cart-qty');
        removeCartItem($productId);
})


checkoutClose.on('click', function() {
    basketContainer.removeClass('open');
    checkoutInfo.hide();
});

basketButton.on('click', function() {
    basketContainer.toggleClass('open');
    checkoutInfo.toggle();
});

// dirty code to hide the checkout container
jQuery(document).mouseup(function(e) {
    var container = jQuery('.checkout-info, .basket-summary');

    if (!container.is(e.target) && container.has(e.target).length === 0) {
        basketContainer.removeClass('open');
        checkoutInfo.hide();
    }
});

function createCheckout()
{
    client.checkout.create().then((checkout) => {
        checkout_id = checkout.id;
        localStorage.setItem('checkout_id', checkout_id);
    });
}

// Check if we already have a checkout ID
let checkout_id = localStorage.getItem('checkout_id');

if (!checkout_id) {
    createCheckout()
}

// Fetch the checkout data
client.checkout.fetch(checkout_id).then((checkout) => {
    updateCartData(checkout);
}).catch( function(err) {
    console.log('Checkout ID not valid');
    createCheckout();
});

function getUpdatedCart(){
    client.checkout.fetch(checkout_id).then((checkout) => {
        updateCartData(checkout);
    }).catch( function(err) {
        console.log('Checkout ID not valid');
        createCheckout();
    });
}

// Fetch the checkout data
getUpdatedCart();

if (process.env.NODE_ENV !== 'production') {
    jQuery('.cart-btn').on('click', function() {
        const variantId = jQuery('.variant-control select').val();
        const lineItemsToAdd = [
            { variantId: variantId, quantity: 1, }
        ];

        client.checkout.addLineItems(checkout_id, lineItemsToAdd).then((checkout) => {
            updateCartData(checkout);
        });
    });
}

/*
|--------------------------------------------------------------------------
| Navigation
|--------------------------------------------------------------------------
*/
const body = document.body;
const navToggle = document.querySelector('.nav-toggle');
// const basketButton = document.querySelector('.basket-summary a');

if (navToggle) {
    navToggle.addEventListener('click', () => body.classList.toggle('-nav-open'));
}

// if (basketButton) {
    
// }

/*
|--------------------------------------------------------------------------
| Home Page Product Slider
|--------------------------------------------------------------------------
*/
const homePageProductSelector = '.page-home .product-carousel';

jQuery(homePageProductSelector).slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: `<button type="button" class="slick-prev">${caretLeft}</button>`,
    nextArrow: `<button type="button" class="slick-next">${caretRight}</button>`,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

/*
|--------------------------------------------------------------------------
| About Page Team Slider
|--------------------------------------------------------------------------
*/
const aboutPageTeamSelector = '.page-about .member-list';

const createTeamCarousel = () => jQuery(aboutPageTeamSelector).slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    prevArrow: `<button type="button" class="slick-prev">${caretLeft}</button>`,
    nextArrow: `<button type="button" class="slick-next">${caretRight}</button>`,
});

const destroyTeamCarousel = () => jQuery(aboutPageTeamSelector).slick('unslick');

/*
|--------------------------------------------------------------------------
| Bio Image Slider
|--------------------------------------------------------------------------
*/
const bioPageCarouselSelector = '.page-about-profile .profile-carousel';
const bioPrevCaret = jQuery(`.page-about-profile .prev-image`);
const bioNextCaret = jQuery(`.page-about-profile .next-image`);

jQuery(bioPageCarouselSelector).slick({
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: bioPrevCaret,
    nextArrow: bioNextCaret,
    customPaging: function(slider, i) {
        let number = i + 1;
        number = number > 9 ? `${number}` : `0${number}`;
        return `<a>${number}</a>`;
    },
    appendDots: '.slick-pages',
    dotsClass: 'pagination-pages',
});

/*
|--------------------------------------------------------------------------
| Product Image Slider
|--------------------------------------------------------------------------
*/
const productPageCarouselSelector = '.page-store-product .product-carousel';
const productPrevCaret = jQuery(`.page-store-product .prev-image`);
const productNextCaret = jQuery(`.page-store-product .next-image`);

if (process.env.NODE_ENV !== 'production') {
    jQuery(productPageCarouselSelector).slick({
        dots: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: productPrevCaret,
        nextArrow: productNextCaret,
        customPaging: function(slider, i) {
            let number = i + 1;
            number = number > 9 ? `${number}` : `0${number}`;
            return `<a>${number}</a>`;
        },
        appendDots: '.slick-pages-mobile',
        dotsClass: 'pagination-pages',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    appendDots: '.slick-pages-tablet',
                }
            },
            {
                breakpoint: 991,
                settings: {
                    appendDots: '.slick-pages-desktop',
                },
            },
        ],
    });
}

/*
|--------------------------------------------------------------------------
| Lookbook Image Carousel
|--------------------------------------------------------------------------
*/
jQuery('.lookbook-post').each(function() {
    const postContainer = jQuery(this);
    const carousel = postContainer.find('.carousel');
    const prevCaret = postContainer.find('.prev-image');
    const nextCaret = postContainer.find('.next-image');
    const pagestContainer = postContainer.find('.slick-pages');

    jQuery(carousel).slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevCaret,
        nextArrow: nextCaret,
        customPaging: function(slider, i) {
            let number = i + 1;
            number = number > 9 ? `${number}` : `0${number}`;
            return `${number}`;
        },
        appendDots: pagestContainer,
        dotsClass: 'pagination-pages',
    });
});

/*
|--------------------------------------------------------------------------
| General Window Events
|--------------------------------------------------------------------------
*/
jQuery(window).on('load resize orientationchange', function() {
    const $carousel = jQuery(aboutPageTeamSelector);

    if (jQuery(window).width() > 768) {
        if ($carousel.hasClass('slick-initialized')) {
            destroyTeamCarousel();
        }
    }
    else {
        if (!$carousel.hasClass('slick-initialized')) {
            createTeamCarousel();
        }
    }
});

/*
|--------------------------------------------------------------------------
| Open External Links in new Window
|--------------------------------------------------------------------------
*/
jQuery('a').each(function() {
   var a = new RegExp("/(www\.)?" + window.location.host + '/');
   if(!a.test(this.href)) {
       jQuery(this).click(function(event) {
           event.preventDefault();
           event.stopPropagation();
           window.open(this.href, '_blank');
       });
   }
});

/*
|--------------------------------------------------------------------------
| Translates using Google Translate
|--------------------------------------------------------------------------
*/
function translationInit() {
    new google.translate.TranslateElement(
        {pageLanguage: 'en'},
        'translation_element'
        );
}